import React from 'react';

import { Check } from 'lucide-react';
import { Link } from 'react-router';

import Pill, { DefaultPillStyles } from 'common/common/Pill';
import LazyLoadedImage from 'common/LazyLoadedImage';
import { Tag } from 'common/subdomain/admin/AdminIntegrationSettings/constants';
import Card from 'common/ui/Card';
import Button from 'common/uiV3/Button';
import HStack from 'common/uiV3/HStack';
import VStack from 'common/uiV3/VStack';

type OnboardingIntegrationCardProps = {
  icon: string | React.ReactNode;
  title: string;
  description: string;
  href: string;
  isInstalled: boolean;
  tag: string | undefined;
  installButtonTitle: string | undefined;
};

const OnboardingIntegrationCard = ({
  icon: Icon,
  title,
  description,
  href,
  isInstalled,
  tag,
  installButtonTitle = 'Install',
}: OnboardingIntegrationCardProps) => {
  return (
    <Card className="px-4 py-3 rounded">
      <HStack className="items-center gap-3">
        {typeof Icon === 'string' ? (
          <LazyLoadedImage src={Icon} alt={title} height={38} width={38} />
        ) : (
          Icon
        )}
        <VStack className="flex-1 gap-1">
          <HStack className="items-center gap-1">
            <div className="text-body font-medium">{title}</div>
            {tag && (
              <Pill pillStyle={tag === Tag.beta ? DefaultPillStyles.beta : DefaultPillStyles.canny}>
                {tag}
              </Pill>
            )}
          </HStack>
          <div className="text-body text-gray-110">{description}</div>
        </VStack>
        <Button asChild variant="outlined" size="small" disabled={isInstalled}>
          <Link to={href} target={href.includes('https://') ? '_blank' : undefined}>
            {isInstalled ? <Check /> : null}
            {isInstalled ? 'Installed' : installButtonTitle}
          </Link>
        </Button>
      </HStack>
    </Card>
  );
};

export default OnboardingIntegrationCard;
